import { mockFactoryStats } from "@/mocks/factoryDashboard";

const stats = [
  {
    label: "Total Revenue",
    value: `$${mockFactoryStats.totalRevenue.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    change: `+${mockFactoryStats.revenueChange}% this month`,
    positive: true,
    icon: "ri-money-dollar-circle-line",
    color: "bg-green-50 text-green-600",
  },
  {
    label: "Total Orders",
    value: mockFactoryStats.totalOrders.toLocaleString(),
    change: `+${mockFactoryStats.ordersChange}% this month`,
    positive: true,
    icon: "ri-shopping-bag-line",
    color: "bg-orange-50 text-orange-500",
  },
  {
    label: "Active Listings",
    value: String(mockFactoryStats.activeListings),
    change: `${mockFactoryStats.newLeads} new leads`,
    positive: true,
    icon: "ri-store-2-line",
    color: "bg-amber-50 text-amber-500",
  },
  {
    label: "Avg Commission",
    value: `${mockFactoryStats.avgCommission}%`,
    change: `${mockFactoryStats.fulfillmentRate}% fulfillment`,
    positive: true,
    icon: "ri-percent-line",
    color: "bg-rose-50 text-rose-500",
  },
  {
    label: "Product Views",
    value: mockFactoryStats.totalViews.toLocaleString(),
    change: `+${mockFactoryStats.viewsChange}% this month`,
    positive: true,
    icon: "ri-eye-line",
    color: "bg-indigo-50 text-indigo-500",
  },
  {
    label: "New Leads",
    value: String(mockFactoryStats.newLeads),
    change: "Awaiting your quote",
    positive: false,
    icon: "ri-mail-open-line",
    color: "bg-teal-50 text-teal-500",
  },
];

export default function FactoryDashboardStats() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8">
      {stats.map((s) => (
        <div key={s.label} className="bg-white rounded-xl border border-gray-100 p-5">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${s.color}`}>
              <i className={`${s.icon} text-lg`} />
            </div>
          </div>
          <div className="text-2xl font-extrabold text-gray-900 mb-0.5">{s.value}</div>
          <div className="text-xs text-gray-500 mb-1">{s.label}</div>
          <div className={`text-xs font-medium ${s.positive ? "text-green-600" : "text-amber-600"}`}>
            {s.change}
          </div>
        </div>
      ))}
    </div>
  );
}
